import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function CashFlyUp({ notifications }) {
  const [flyUps, setFlyUps] = useState([]);

  useEffect(() => {
    const latest = notifications[notifications.length - 1];
    if (!latest || latest.read) return;
    // Match sale notifications
    const match = latest.message?.match(/\+\$([0-9,]+)/);
    if (match) {
      const id = latest.id;
      setFlyUps(prev => [...prev.slice(-3), { id, text: `+$${match[1]}`, ts: Date.now() }]);
      setTimeout(() => setFlyUps(prev => prev.filter(f => f.id !== id)), 1500);
    }
  }, [notifications.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ position: 'fixed', top: 60, right: 20, pointerEvents: 'none', zIndex: 600 }}>
      <AnimatePresence>
        {flyUps.map(f => (
          <motion.div
            key={f.id}
            initial={{ opacity: 1, y: 0 }}
            animate={{ opacity: 0, y: -40 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2, ease: 'easeOut' }}
            style={{
              color: 'var(--green)',
              fontWeight: 700,
              fontSize: 18,
              textShadow: '0 2px 8px rgba(0,0,0,0.6)',
            }}
          >
            {f.text}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
